<template>
    <div class="data_body">
        <div style="width: 100%; height: 100%" >
            <div id="charts_canvas" class="echart" style="width: 100%; height: 100%; "></div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        courseArray: {
            type: Object,
        },
    },
    data() {
        return {
            chartObj: null,
            ooption: {
                hours: [],
                days: [],
                data: [],
            },
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '3%',
                    bottom: '3%',
                    top: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'value'
                    }
                ],
                yAxis: [
                    {
                        type: 'category',
                        // data: ['综合', '艺术', '英语', '数学', '语文'],
                        data: [],
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                series: [
                    {
                        name: '',
                        type: 'bar',
                        barWidth: '60%',
                        // data: [100, 502, 200, 334, 390, 330, 220]
                        data: []
                    }
                ]
            },
        };
    },
    methods: {
        setChart(option) {
            // 雷达图显示的标签
            let newPromise = new Promise((resolve) => {
                resolve();
            });
            //然后异步执行echarts的初始化函数
            newPromise.then(() => {
                const chartObj = this.$echarts.init(
                    //劳动课程
                    this.$el.querySelector("#charts_canvas")
                );
                this.option.yAxis[0].data = option.yAxis
                this.option.series[0].data = option.data
                // 初始化雷达图
                this.chartObj = chartObj;
                this.chartObj.setOption(this.option);
            });
        },
        setJson(array) {
            if (Object.keys(array).length > 0) {
                this.ooption = {
                    yAxis: Object.keys(array),
                    data: [],
                }
                for (let i = 0; i < Object.keys(array).length; i++) {
                    this.ooption.data.push(array[Object.keys(array)[i]]);
                }

                if (!this.chartObj) {
                    this.setChart(this.ooption);
                } else {
                    this.option.yAxis[0].data = this.ooption.yAxis
                    this.option.series[0].data = this.ooption.data
                    this.chartObj.setOption(this.option);
                }
            }
        }
    },
    watch: {
        courseArray: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {

                this.setJson(newValue)
                this.$forceUpdate();
            },
        },
    },
    mounted() {
        this.setChart(this.ooption);
        this.setJson(this.courseArray)
        var _this = this;
        window.addEventListener("resize", () => {
            if (_this.chartObj) {
                _this.chartObj.resize();
            }
        });
    },
};
</script>
  
<style scoped>
.data_body {
    height: 100%;
    position: relative;
    border-radius: 5px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0;
    width: 95%;
    background: #fff;
    overflow: hidden;
}
</style>
  


// WEBPACK FOOTER //
// src/components/pages/dataBoardTest/course/chartList/cateRank.vue